import '../../styles/Source-Link.css';

export default function SourceLinks({
  link1, link2, link3, link4, link5, link6, link7, link8,
  customText1, customText2, customText3, customText4, customText5, customText6, customText7, customText8
}) {

  const links = [
    { href: link1, text: customText1 },
    { href: link2, text: customText2 },
    { href: link3, text: customText3 },
    { href: link4, text: customText4 },
    { href: link5, text: customText5 },
    { href: link6, text: customText6 },
    { href: link7, text: customText7 },
    { href: link8, text: customText8 },
  ];

  const validLinks = links.filter(link => link.href && link.text);

  if (validLinks.length === 0) return null;

  return (
    <div>
      <p className="info-text">
        Fontes:
        {validLinks.map((link, index) => (
          <a
            key={index}
            href={link.href}
            className="source-link"
            target="_blank"
            rel="noreferrer"
          >
            {link.text}
          </a>
        ))}
      </p>
    </div>
  );
}
